import {
    AcceptTotalExternalInvoicePaidAmountInReconciliation,
    AcceptTotalMembershipPaidAmountInReconciliation,
    AcceptTotalPaidAmountInReconcilation,
    AcceptTotalPurchaseChapterPaidAmountInReconciliation,
    GetBookingCancellationDetailsById,
    GetBookingCancellationList,
    GetBookingDetailsByBookingId,
    GetBookingDetailsById,
    GetbookingsList,
    GetEventPaymentReconcilationList,
    SavePaymentReconcilationDetailsByAdmin,
    DeleteEventPaymentReconcilation,
    GetOutstandingInvoicesList,
    AddProofInPaymentProofMapping,
    GetAllDropdownsForIndividualBooking,
    DownloadBookingSheetByEventId,
    GetPaymentProofListDetailsByPaymentProofId,
    DownloadReconciliationExcelTemplate,
    ApproveAndUpdatePaymentHistoryForRenewMembershipPayment,
    UpdatePaymentProofMappingStatusForRenewMembershipPayment,
    ApproveAndUpdatePaymentHistoryForReinstatementPayment,
    GetAllBookingWaitingList,
    GetBookingWaitingDetailsById,
    ExportAllViewWaitingMembers,
    SendMailToOutStandingInvoiceById,
    SendMailToSeatreleaseById,
    RejectBookingRequestForCancellation,
    ApproveBookingRequestForCancellation,
    GetNewBookingDetailsById,
    UpdateNewBookingDetailsById,
      DownloadBookingSheetByEventIdSpecificEvents
} from '../ApiEndPoints';
import { axiosGetAuthorize, axiosPostAuthorize, axiosGetMultiParams, axiosGetFileAuthorizeblob, axiosGetAuthorizeMultiParams,axiosPostFileAuthorizeblob } from '../AxiosRequests';


export default class BookingServices {

    async getbookingsList(request) {
        return axiosPostAuthorize(GetbookingsList, request)
    }
    async getbookingsCancellationList(request) {
        return axiosPostAuthorize(GetBookingCancellationList, request)
    }
    async getBookingDetailsById(request) {
        return axiosGetAuthorize(GetBookingDetailsById, request);
    }
    async getBookingCancellationDetailsById(request) {
        return axiosGetAuthorize(GetBookingCancellationDetailsById, request);
    }
    async getBookingDetailsByBookingId(request) {
        return axiosGetMultiParams(GetBookingDetailsByBookingId, request);
    }
    async getEventPaymentReconcilationList(request) {
        return axiosPostAuthorize(GetEventPaymentReconcilationList, request)
    }
    async getPaymentProofListDetailsByPaymentProofId(request) {
        return axiosGetAuthorizeMultiParams(GetPaymentProofListDetailsByPaymentProofId, request)
    }
    async savePaymentReconcilationDetailsByAdmin(request) {
        return axiosPostAuthorize(SavePaymentReconcilationDetailsByAdmin, request);
    }
    async acceptTotalPaidAmountInReconcilation(request) {
        return axiosGetMultiParams(AcceptTotalPaidAmountInReconcilation, request);
    }
    async acceptTotalMembershipPaidAmountInReconciliation(request) {
        return axiosPostAuthorize(AcceptTotalMembershipPaidAmountInReconciliation, request);
    }
    async approveAndUpdatePaymentHistoryForReinstatementPayment(request) {
        return axiosPostAuthorize(ApproveAndUpdatePaymentHistoryForReinstatementPayment, request);
    }
    async approveAndUpdatePaymentHistoryForRenewMembershipPayment(request) {
        return axiosPostAuthorize(ApproveAndUpdatePaymentHistoryForRenewMembershipPayment, request);
    }
    async updatePaymentProofMappingStatusForRenewMembershipPayment(request) {
        return axiosPostAuthorize(UpdatePaymentProofMappingStatusForRenewMembershipPayment, request);
    }
    async acceptTotalExternalInvoicePaidAmountInReconciliation(request) {
        return axiosGetAuthorize(AcceptTotalExternalInvoicePaidAmountInReconciliation, request);
    }
    // async acceptTotalPurchaseChapterPaidAmountInReconciliation(request) {
    //     return axiosGetAuthorize(AcceptTotalPurchaseChapterPaidAmountInReconciliation, request);
    // }
    async acceptTotalPurchaseChapterPaidAmountInReconciliation(request) {
        return axiosGetAuthorizeMultiParams(AcceptTotalPurchaseChapterPaidAmountInReconciliation, request);
    }
    async deleteEventPaymentReconcilation(request) {
        return axiosPostAuthorize(DeleteEventPaymentReconcilation, request)
    }
    async getOutstandingInvoicesList(request) {
        return axiosPostAuthorize(GetOutstandingInvoicesList, request)
    }
    async addProofInPaymentProofMapping(request) {
        return axiosPostAuthorize(AddProofInPaymentProofMapping, request);
    }

    async getAllDropdownsForIndividualBooking(request) {
        return axiosGetAuthorize(GetAllDropdownsForIndividualBooking, request);
    }
    async downloadBookingSheetByEventId(request) {
        return axiosGetFileAuthorizeblob(DownloadBookingSheetByEventId, request);
    }
    async downloadReconciliationExcelTemplate(request){
        return axiosGetFileAuthorizeblob(DownloadReconciliationExcelTemplate, request);
    }

    async getAllBookingWaitingList(request) {
        return axiosPostAuthorize(GetAllBookingWaitingList, request)
    }
    async getBookingWaitingDetailsById(request) {
        return axiosGetAuthorizeMultiParams(GetBookingWaitingDetailsById, request)
    }
    async exportAllViewWaitingMembers(request) {
        return axiosPostFileAuthorizeblob(ExportAllViewWaitingMembers, request);
    }
    async sendMailToOutStandingInvoiceById(request){
        return axiosGetAuthorize(SendMailToOutStandingInvoiceById,request);
    }
    async sendMailToSeatreleaseById(request){
        return axiosGetAuthorize(SendMailToSeatreleaseById,request);
    }
    async rejectBookingRequestForCancellation(request) {
        return axiosPostAuthorize(RejectBookingRequestForCancellation, request)
    }
    async approveBookingRequestForCancellation(request) {
        return axiosPostAuthorize(ApproveBookingRequestForCancellation, request)
    }
    async getNewBookingDetailsById(request) {
        return axiosGetAuthorize(GetNewBookingDetailsById, request);
    }
    async updateNewBookingDetailsById(request) {
        return axiosPostAuthorize(UpdateNewBookingDetailsById, request);
    }

     async downloadBookingSheetByEventIdSpecificEvents(request) {
        return axiosGetFileAuthorizeblob(DownloadBookingSheetByEventIdSpecificEvents, request);
        }
}